import * as z from 'zod/mini';
export const PatientDataType = z.enum(['PL_PESEL', 'DOCUMENT_NUMBER']);
//# sourceMappingURL=PatientDataType.js.map